export const getAdvisoryDetails = (state) => {
  return state.advisoryDetails.details ? state.advisoryDetails.details : [];
};
